import {
	IconButton,
	InputBase,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	makeStyles,
	useMediaQuery,
} from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import theme from '@ifca-root/react-component/src/assets/theme';
import AppContext from 'containers/App/Store/AppContext';
import React, { useContext, useState } from 'react';

interface ISearchHeaderProps {
	title: string;
	value?: string;
	onClick?: any;
	input?: any;
	option?: {
		onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
		icon?: any;
	};
	search?: boolean;
	onChangeAction?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onCloseAction?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	dynamicInfo?: boolean;
	multiDynamicInfo?: boolean;
	multiDynamicSubInfo?: boolean;
	fixed?: boolean;
	clickText?: boolean;
	singleInfo?: boolean;
	dropdownInfo?: boolean;
	defaultValue?: string;
	isDefaultValue?: boolean;
	datePickerSubInfo?: boolean;
}

export const SearchHeaderRetail = (props: ISearchHeaderProps) => {
	const {
		title,
		value,
		search,
		option,
		input,
		onChangeAction,
		onCloseAction,
		dynamicInfo,
		multiDynamicInfo,
		multiDynamicSubInfo,
		fixed,
		singleInfo,
		dropdownInfo,
		clickText,
		defaultValue,
		isDefaultValue,
		datePickerSubInfo,
	} = props;

	const [removeDefault, setRemoveDefault] = useState(
		isDefaultValue ? false : true,
	);

	const [Empty, setEmpty] = useState(false);
	const handleSearchToggle = (boolean: boolean) => {
		setRemoveDefault(boolean);
	};

	const { globalState }: any = useContext(AppContext as any);
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const useStyles = makeStyles((theme) => ({
	list: {
    	width: '100%',

		[theme.breakpoints.down('xs')]: {
		minWidth: '100vw',   // 🔥 this is what you want
		},
	},
	}));

	const classes = useStyles();

	return (
		<List
			id="search-header"
			className={`${classes.list} search-header`}
			style={{
				width: '100%', // 🔥 IMPORTANT — fill container
				boxSizing: 'border-box', // 🔥 prevents overflow
				margin: 0,
				padding: 0,
				background: '#fff',
				position: 'relative',
				zIndex: 10,
			}}
		>
			{/* HEADER TITLE + BUTTONS */}
			<ListItem style={{ width: '100%'}}>
				<ListItemText
					disableTypography
					onClick={() => clickText && handleSearchToggle(false)}
					primary={
						<span className="xsTitle flex-space" style={{ color: '#000' }}>
							{title}{' '}
							{value && (
								<>
									(<span className="highlight-text">{value}</span>)
								</>
							)}
						</span>
					}
				/>

				<ListItemSecondaryAction>
					{search && (
						<IconButton
							edge="end"
							aria-label="search"
							onClick={() => {
								handleSearchToggle(false);
								setEmpty(false);
							}}
						>
							<Search />
						</IconButton>
					)}

					{option && (
						<IconButton edge="end" onClick={option?.onClick}>
							{option?.icon}
						</IconButton>
					)}
				</ListItemSecondaryAction>
			</ListItem>

			{/* INPUT FIELD */}
			<ListItem
				className={`search-field ${!removeDefault ? '' : 'hide'}`}
				style={{ width: '100%' }} // 🔥 ensure full width
			>
				<ListItemText
					disableTypography
					primary={
						<InputBase
							placeholder="Search here.."
							onChange={onChangeAction}
							defaultValue={defaultValue}
							fullWidth // 🔥 critical for full width search
							inputRef={input => {
								input && Empty && (input.value = '');
							}}
						/>
					}
				/>

				<ListItemSecondaryAction>
					<IconButton
						edge="end"
						aria-label="close"
						onClick={e => {
							handleSearchToggle(true);
							onCloseAction?.(e);
							setEmpty(true);
						}}
						className={`close-search ${!removeDefault ? '' : 'hide'}`}
					>
						<Close />
					</IconButton>
				</ListItemSecondaryAction>
			</ListItem>
		</List>
	);
};
